import loadable from '@loadable/component';

const Booking = loadable(() => import('./Booking'));
export default Booking;
